import { defineStore } from "pinia";
import { reactive } from "vue";

export const useUserResponse = defineStore(
  "userresponse",
  () => {
    const activeTraining = reactive({
      trainingId: "",
      amountOfQuestions: 0,
    });

    const userResponse = reactive({
      trainingId: "",
      response: [],
    });

    return {
      activeTraining,
      userResponse,
    };
  },
  {
    persist: true,
  }
);
